import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _extends from "@babel/runtime/helpers/extends";

function _createSuper(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent, cloneElement } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ClearIcon from '../icons/forms/ClearIcon';
import VisibilityAnimation from '../VisibilityAnimation';
import OnClickOutside from '../OnClickOutside';
import renderToLayer from '../hoc/render-to-layer';
import zIndexStack from '../hoc/z-index-stack';
import { SNACKBAR_ZINDEX } from '../constants/z-indexes';
import { withStyles } from '../theme';
import compose from '../utils/compose';
import { isolateMixin, middleMixin, ifDesktop } from '../utils/mixins';

var styles = function styles(theme) {
  return {
    snackbar: _extends({
      extend: [isolateMixin, middleMixin],
      fontFamily: theme.fontFamily,
      position: 'fixed',
      boxSizing: 'border-box',
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      padding: theme.snackbar.sizes.medium.padding,
      width: '100%',
      lineHeight: theme.snackbar.lineHeight,
      color: theme.snackbar.colors.text,
      fontSize: theme.snackbar.fontSize,
      fontWeight: theme.snackbar.fontWeight,
      opacity: 0,
      transitionDuration: theme.snackbar.animationDuration,
      transitionProperty: 'top, bottom, opacity'
    }, ifDesktop({
      width: 'auto',
      minWidth: 350,
      maxWidth: theme.snackbar.maxWidth,
      borderRadius: theme.snackbar.borderRadius
    })),
    top: _extends({
      top: -10
    }, ifDesktop({
      top: 0
    }), {
      '&$isVisible': _extends({
        top: 0
      }, ifDesktop({
        top: 10
      }))
    }),
    bottom: _extends({
      bottom: -10
    }, ifDesktop({
      bottom: 0
    }), {
      '&$isVisible': _extends({
        bottom: 0
      }, ifDesktop({
        bottom: 10
      }))
    }),
    isVisible: {
      opacity: 1
    },
    left: _extends({
      left: 0
    }, ifDesktop({
      left: 10
    })),
    center: {
      left: '50%',
      transform: 'translateX(-50%)'
    },
    right: _extends({
      right: 0
    }, ifDesktop({
      right: 10
    })),
    main: {
      backgroundColor: theme.snackbar.colors.background.main
    },
    primary: {
      backgroundColor: theme.snackbar.colors.background.primary
    },
    success: {
      backgroundColor: theme.snackbar.colors.background.success
    },
    danger: {
      backgroundColor: theme.snackbar.colors.background.danger
    },
    icon: {
      extend: middleMixin,
      marginRight: 15
    },
    content: {
      flexGrow: 1,
      textAlign: 'left'
    },
    button: {
      boxSizing: 'border-box',
      outline: 'none',
      flexShrink: 0,
      border: 0,
      borderRadius: theme.snackbar.borderRadius,
      height: 20,
      lineHeight: 20 + 'px',
      marginLeft: 15,
      padding: '0 10px',
      backgroundColor: 'transparent',
      color: theme.snackbar.colors.actionButton,
      fontSize: theme.snackbar.fontSize,
      fontWeight: theme.snackbar.fontWeight,
      textAlign: 'center',
      textTransform: 'uppercase',
      letterSpacing: 1,
      cursor: 'pointer',
      transitionDuration: '.2s',
      transitionProperty: 'background-color, border',
      '&:hover:not(:active)': {
        backgroundColor: 'rgba(0, 0, 0, 0.05)'
      },
      '&:focus:not(:active)': {
        border: '1px solid'
      },
      '&:active': {
        backgroundColor: 'rgba(0, 0, 0, 0.1)'
      }
    },
    close: {
      composes: '$button',
      extend: middleMixin,
      borderRadius: '50%',
      width: 20,
      padding: 0,
      lineHeight: 0
    },
    small: {
      padding: theme.snackbar.sizes.small.padding
    }
  };
};

var Snackbar = /*#__PURE__*/function (_PureComponent) {
  _inherits(Snackbar, _PureComponent);

  var _super = _createSuper(Snackbar);

  function Snackbar() {
    var _this;

    _classCallCheck(this, Snackbar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.onWillVisible = function () {
      if (_this.props.autoCloseDuration) _this.autoCloseTimeout = setTimeout(function () {
        _this.props.onRequestClose();
      }, _this.props.autoCloseDuration);
    };

    _this.onWillInvisible = function () {
      clearTimeout(_this.autoCloseTimeout);
    };

    _this.onClickOutside = function () {
      if (_this.props.isOpened) _this.props.onRequestClose();
    };

    _this.renderContent = function (componentRef) {
      var _this$props = _this.props,
          isOpened = _this$props.isOpened,
          children = _this$props.children,
          className = _this$props.className,
          positionX = _this$props.positionX,
          positionY = _this$props.positionY,
          type = _this$props.type,
          style = _this$props.style,
          theme = _this$props.theme,
          icon = _this$props.icon,
          showClose = _this$props.showClose,
          actionButton = _this$props.actionButton,
          onAction = _this$props.onAction,
          onRequestClose = _this$props.onRequestClose,
          onClose = _this$props.onClose,
          size = _this$props.size,
          classes = _this$props.classes;
      return React.createElement(VisibilityAnimation, {
        isVisible: isOpened,
        animationDuration: theme.snackbar.animationDuration,
        onWillVisible: _this.onWillVisible,
        onWillInvisible: _this.onWillInvisible,
        onInvisible: onClose
      }, function (_ref) {
        var isVisible = _ref.isVisible;
        return React.createElement("div", {
          ref: componentRef,
          style: style,
          className: classnames(classes.snackbar, classes[positionX], classes[positionY], classes[type], className, isVisible && classes.isVisible, size === 'small' && classes.small)
        }, icon && React.createElement("div", {
          className: classes.icon
        }, cloneElement(icon, {
          color: icon.props.color || theme.snackbar.colors.text
        })), React.createElement("div", {
          className: classes.content
        }, children), actionButton && React.createElement("button", {
          type: "button",
          className: classes.button,
          onClick: onAction
        }, actionButton), showClose && React.createElement("button", {
          type: "button",
          className: classes.close,
          onClick: onRequestClose
        }, React.createElement(ClearIcon, {
          size: 10,
          color: theme.snackbar.colors.text
        })));
      });
    };

    return _this;
  }

  _createClass(Snackbar, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.onWillInvisible();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var closeOnClickOutside = this.props.closeOnClickOutside;
      if (closeOnClickOutside) return React.createElement(OnClickOutside, {
        handler: this.onClickOutside
      }, function (componentRef) {
        return _this2.renderContent(componentRef);
      });
      return this.renderContent();
    }
  }]);

  return Snackbar;
}(PureComponent);

Snackbar.defaultProps = {
  type: 'main',
  isOpened: false,
  positionX: 'center',
  positionY: 'bottom',
  showClose: false,
  closeOnClickOutside: false,
  autoCloseDuration: 4000,
  onAction: function onAction() {},
  onRequestClose: function onRequestClose() {},
  size: 'medium'
};
Snackbar.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Css-класс
   */
  className: PropTypes.string,

  /**
   * Inline-стили
   */
  style: PropTypes.object,

  /**
   * Контент снэкбара
   */
  children: PropTypes.node.isRequired,

  /**
   * Контролирует видимость снэкбара
   */
  isOpened: PropTypes.bool,

  /**
   * Тип цвета снэкбара
   */
  type: PropTypes.oneOf(['main', 'primary', 'success', 'danger']),

  /**
   * Иконка
   */
  icon: PropTypes.node,

  /**
   * Кнопка действия
   */
  actionButton: PropTypes.string,

  /**
   * Позиция по оси X
   */
  positionX: PropTypes.oneOf(['left', 'center', 'right']),

  /**
   * Позиция по оси Y
   */
  positionY: PropTypes.oneOf(['top', 'bottom']),

  /**
   * Кнопка закрытия
   */
  showClose: PropTypes.bool,

  /**
   * Закрытие по клику вне
   */
  closeOnClickOutside: PropTypes.bool,

  /**
   * Таймаут авто-закрытия
   */
  autoCloseDuration: PropTypes.number,

  /**
   * Коллбек вызывающийся при нажатии на кнопку действия
   */
  onAction: PropTypes.func,

  /**
   * Коллбек вызывающийся при всех вариантах закрытия (автоматически проставляется, если используется `@provideSnackbar`)
   */
  onRequestClose: PropTypes.func,

  /**
   * Коллбек вызывающийся после закрытия
   */
  onClose: PropTypes.func,

  /**
   * Высота снэкбара
   */
  size: PropTypes.oneOf(['small', 'medium'])
} : {};
export default compose(zIndexStack(SNACKBAR_ZINDEX), renderToLayer, withStyles(styles, {
  name: 'Snackbar'
}))(Snackbar);